import type { CartLineItem } from "../components/cart/CartContext"

/**
 * Calculates the diff between two carts with respect to variant quantities
 */
export const getCartDiff = (
  currCart: CartLineItem[],
  prevCart: CartLineItem[],
) => {
  const diff = prevCart.reduce((acc, lineItem) => {
    acc.set(lineItem.id, lineItem)
    return acc
  }, new Map<string, CartLineItem>())

  currCart.forEach((lineItem) => {
    const prevLineItem = diff.get(lineItem.id)
    const diffLineItem = prevLineItem
      ? {
          ...lineItem,
          quantity: lineItem.quantity - prevLineItem.quantity,
        }
      : lineItem

    diff.set(lineItem.id, diffLineItem)
  })

  return diff
}
